import { LDObserve } from '@launchdarkly/observability';

// Narrow structural type so consumers don't need to add @opentelemetry/api
// as a direct dependency to end the manual span.
export interface RouteViewSpan {
  end(): void;
}

export interface RouteViewSpanOptions {
  url: string;
  pathTemplate?: string;
  owner?: string;
}

export function startRouteViewSpan({ url, pathTemplate, owner }: RouteViewSpanOptions): RouteViewSpan | undefined {
  // The SDK's startManualSpan runs the callback inside the span's context and
  // returns whatever the callback returns. Build the narrow RouteViewSpan shape
  // in the callback so the return type flows through without an `as` cast —
  // consumers still don't need @opentelemetry/api to end the span.
  const span: RouteViewSpan | undefined = LDObserve.startManualSpan(
    'route_view',
    {
      attributes: {
        'page_view.url': url,
        ...(pathTemplate ? { 'page_view.path_template': pathTemplate } : {}),
        ...(owner ? { 'page_view.owner': owner } : {}),
      },
    },
    (s) => ({ end: () => s.end() }),
  );
  return span;
}
